<app-download-confirmed-popup #confirmedUpload_ref [moduleName]="moduleName | titlecase" [action]="'upload'"></app-download-confirmed-popup>
<p-dialog
  [styleClass]="'popup_import'"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [style]="{ width: '40%' }"
  [modal]="true"
  [visible]="show_ImportDialog"
>
  <ng-template pTemplate="header">
    <div
      class="flex wd-100 dialog_header_wrapper align-items-center justify-content-between ng-star-inserted"
    >
      <span class="text-xl font-bold">{{ dialog_header }}</span>
      <p-button
        icon="pi pi-times"
        (onClick)="hide()"
        styleClass="p-button-rounded p-button-danger p-button-text p-button-raised"
      ></p-button>
    </div>
  </ng-template>

  <div
    class="import_content_wrapper"
    [ngClass]="
      import_stage == 'upload_detail'
        ? null
        : genericError_Visible
        ? 'flex gap-4 flex-column align-items-center justify-content-end'
        : 'flex flex-column align-items-center justify-content-center'
    "
    DragndropFile
    (files)="onFileDrop($event)"
  >
    <ng-container>
      <!-- Show image preview if available, otherwise show upload icon -->
      <div *ngIf="imagePreviewUrl && importType === 'image'; else uploadIcon" class="image-preview-container">
        <img
          [src]="imagePreviewUrl"
          alt="Preview"
          class="image-preview"
          (click)="fubauto.choose()"
          title="Click to change image"
        />
        <button
          class="delete-image-btn"
          (click)="deleteCurrentImage()"
          title="Delete image">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <ng-template #uploadIcon>
        <div><img src="../../../../assets/images/upload.svg" /></div>
      </ng-template>

      <p class="content_label mt-2">
        <span *ngIf="!imagePreviewUrl && !file_name">
          Drag and Drop file here or
        </span>
        <span *ngIf="imagePreviewUrl && importType === 'image'">
          Click image to change or
        </span>
        <span *ngIf="file_name && importType === 'document' && !imagePreviewUrl">
          Click file to change or
        </span>
                 <span
           ><p-fileUpload
             #fubauto
             mode="basic"
             [classList]="' import_browse'"
             [accept]="importType === 'image' ? '.jpeg,.jpg,.png' : importType === 'all' ? '.jpeg,.jpg,.png,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt' :  importType === 'document' ? '.pdf,.doc,.docx,.jpeg,.jpg,.png' :'.csv,.xlsx'"
             [multiple]="importType === 'image' || importType === 'all'"
             (onSelect)="onBasicUploadAuto($event)"
             chooseLabel="Choose file"
             [auto]="true"
             [showCancelButton]="false"
           ></p-fileUpload
         ></span>
      </p>
      <p-messages
        severity="error"
        [className]="'import-error'"
        *ngIf="importError_Visible"
      >
        <ng-template pTemplate>
          <p-button
            icon="pi pi-times"
            (onClick)="fubauto.clear(); importError_Visible = false"
            styleClass="p-button-rounded p-button-danger p-button-text p-button-raised"
          ></p-button>
          <span class="custom-message">{{ importError_Message }}</span>
        </ng-template>
      </p-messages>
    </ng-container>
  </div>
  <div class="flex justify-content-between mt-1">
         <span class="typo-supported-format">Support formats: {{ importType === 'image' ? 'JPG, JPEG, PNG' : importType === 'all' ? 'JPG, JPEG, PNG, PDF, DOC, XLS, CSV, TXT' :importType === 'document' ? 'PDF, DOC, DOCX, JPG, JPEG, PNG' : 'XLSX, CSV' }}</span>
    <span class="typo-supported-format">Maximum size: {{ (maxFileSize / 1024 / 1024).toFixed(0) }}  MB</span>
  </div>
  <div *ngIf="import_stage !== 'upload_progress'  && importType === 'data'" class="file-info mt-3">
    <div class="flex align-items-center">
      <div class="flex-1">
        <div class="flex gap-2">
          <img
            style="width: 20px"
            src="../../../assets/images/excel-logo.png"
          />
          <p class="font-poppin fw-600 text-color-black fs-12">Sample File</p>
        </div>
        <p class="font-poppin fw-500 text-color-grey3 fs-10 mt-3">
          You can download the attached example and use them as a starting point
          for your own file.
        </p>
      </div>
      <div>
        <p-button
          type="button"
          label="Download"
          class="p-button-text elevated-btn secondary"
          (click)="downloadTemplate()"
        ></p-button>
      </div>
    </div>
  </div>

  <!-- Multiple files display for image and all types -->
  <div *ngIf="(importType === 'image' || importType === 'all') && uploadedFiles.length > 0" class="uploaded-files-container mt-3">
    <div class="flex align-items-center justify-content-between mb-2">
      <h4 class="font-poppin fw-600 text-color-black fs-14">Uploaded Files</h4>
      <p-button
        type="button"
        label="Clear All"
        class="p-button-text p-button-sm elevated-btn secondary"
        (click)="clearAllFiles()"
      ></p-button>
    </div>
    <div class="uploaded-files-list">
      <div *ngFor="let file of uploadedFiles; let i = index"
           class="uploaded-file-item flex align-items-center justify-content-between p-2 mb-2"
           [ngStyle]="{ border: '1px solid #ccc', borderRadius: '4px' }">
        <div class="flex align-items-center gap-2">
          <img
            [src]="file.preview"
            [alt]="file.name"
            style="width: 20px; height: 20px; object-fit: cover;"
          />
          <span class="font-poppin fw-500 text-color-black fs-12">{{ file.name }}</span>
        </div>
        <div>
          <i class="cursor-pointer pi pi-times text-color-red" (click)="removeFile(i)" title="Remove file"></i>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="import_stage === 'upload_progress' && importType === 'data'"
    [ngStyle]="{ border: error_Visible || !Is_ValidFile ? '1px solid red' : 'none' }"
    class="file-info mt-3"
  >
    <div class="flex align-items-center">
      <div class="flex-1">
        <div class="flex justify-content-between">
          <div class="flex gap-2">
            <img
              style="width: 20px;"
              src="../../../assets/images/excel-logo.png"
            />
            <p class="font-poppin fw-600 text-color-black fs-12">
              {{file_name}}
            </p>
          </div>
          <div>
            <i class="cursor-pointer pi pi-times" (click)="uploadCancel()"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- File info display for documents (PDF, DOC, etc.) -->
  <div
    *ngIf="import_stage === 'upload_progress' && importType === 'document'"
    [ngStyle]="{ border: error_Visible || !Is_ValidFile ? '1px solid red' : 'none' }"
    class="file-info mt-3"
  >
    <div class="flex align-items-center">
      <div class="flex-1">
        <div class="flex justify-content-between">
          <div class="flex gap-2">
            <i
              [class]="file_extension === 'pdf' ? 'pi pi-file-pdf' :
                       ['doc', 'docx'].includes(file_extension) ? 'pi pi-file-word' :
                       ['jpeg', 'jpg', 'png'].includes(file_extension) ? 'pi pi-image' : 'pi pi-file'"
              style="font-size: 20px;"
            ></i>
            <p class="font-poppin fw-600 text-color-black fs-12">
              {{file_name}}
            </p>
          </div>
          <div>
            <i class="cursor-pointer pi pi-times" (click)="uploadCancel()"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="error_Visible" class="error-container p-3 mt-3">
    <div *ngFor="let error of errors; let i = index">
      <div class="flex align-items-center gap-2" id="error-{{ i }}">
        <div>
          <img
            src="../../../assets/images/close-icon.svg"
            width="8px"
            height="8px"
            alt="close"
          />
        </div>
        <div class="font-poppin fw-500 fs-10 text-color-red">{{ error }}</div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex align-items-center flex gap-3 justify-content-end">
      <p-button
        type="button"
        label="Cancel"
        class="p-button-text elevated-btn secondary"
        (click)="hide()"
      ></p-button>
      <p-button
        type="button"
        label="Upload"
        class="p-button-text elevated-btn primary mr-2"
        (onClick)="submit_file(file)"
        [disabled]="getUploadButtonDisabled()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
